import { createApp, reactive } from 'vue'; // 引入reactive
import App from './App.vue';
import router from './router';
import validatorPlugin from './plugins/validatorPlugin';
import bignumber from './plugins/bignumber';
import chatPlugin from './plugins/chat';
import axiosInstance from './plugins/axios'; // 导入你的 axios 实例
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs' // 中文语言包
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import QRCodeVue from 'qrcode.vue'

const app = createApp(App)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}
const globalData = reactive({
  to_report_num: '', // 现在这个变量是响应式的
  to_edit_num:''
});
// 将 axios 实例注入到所有组件中，使其全局可用
app.config.globalProperties.$axios = axiosInstance;
// 注册全局变量
app.config.globalProperties.$globalData = globalData

app.component('qrcode-vue', QRCodeVue) // 注意组件名匹配
app.use(router);
app.use(validatorPlugin)
app.use(bignumber)
app.use(chatPlugin, {
  url: 'wss://www.tuoshouwang.com:8282',
  reconnectInterval: 3000
});

app.use(ElementPlus, {
  locale: zhCn, // 设置为中文
})
const vm =app.mount('#app');
// 定义定时请求函数
function fetchDataPeriodically() {
  if (!localStorage.getItem('user_id')) {
    return false
  }
  // 执行请求
  vm.$axios.post('/api/yunsys.Website/getnums') // 替换为你的API地址
    .then(response => {
      // 更新全局变量
      vm.$globalData.to_report_num = response.data.data.to_report_num;
      vm.$globalData.to_edit_num = response.data.data.to_edit_num;
     
    })
    .catch(error => {
      //console.error('Error fetching data:', error);
    });
}
app.config.globalProperties.$fetchDataPeriodically = fetchDataPeriodically;
// 立即执行一次，然后每10秒执行一次
fetchDataPeriodically();
setInterval(fetchDataPeriodically, 10000); // 10000毫秒 = 10秒
